/** Prevents stale CXone events (e.g. voicemail teardown) from reopening call controls during ACW. */
import { logger } from '../../utils/logger';

let lockedContactId: string | null = null;

export function lockAcwUi(contactId: string | null | undefined): void {
  if (!contactId) {
    return;
  }
  lockedContactId = contactId;
  logger.lifecycle('[ACW Flow] lockAcwUi', { contactId });
}

export function unlockAcwUi(): void {
  if (lockedContactId) {
    logger.lifecycle('[ACW Flow] unlockAcwUi', { contactId: lockedContactId });
  }
  lockedContactId = null;
}

export function isAcwUiLocked(): boolean {
  return lockedContactId !== null;
}

export function getAcwLockedContactId(): string | null {
  return lockedContactId;
}

/** True when a live-call signal should be ignored because we are in post-call ACW for this contact. */
export function shouldIgnoreStaleLiveCall(contactId: string | null | undefined): boolean {
  if (!lockedContactId) {
    return false;
  }
  if (!contactId) {
    return true;
  }
  return contactId === lockedContactId;
}
